import { createContext, useEffect, useState, useContext } from 'react';
import { getAuthToken, fetchGuestToken } from './authService';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const ensureToken = async () => {
      let token = getAuthToken();
      if (!token) {
        await fetchGuestToken();
      }
      setAuthReady(true);
    };
    ensureToken();
  }, []);

  return (
    <AuthContext.Provider value={{ authReady }}>
      {authReady ? children : <div>Loading...</div>}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  return useContext(AuthContext);
}
